/**
 * 项目管理
 * **/

const userApi = {
  //获取列表
  getList: '/SysUser/GetList',
  //获取信息
  getInfo: '/SysUser/GetInfo',
  //添加
  add: '/SysUser/Add',
  //修改
  edit: '/SysUser/Edit',
  //删除
  delete: '/SysUser/Del',
}

export default userApi
